/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-3",
    "aws_cognito_identity_pool_id": "eu-west-3:a9abf6a8-ae27-4a97-8ceb-8e819e860f3b",
    "aws_cognito_region": "eu-west-3",
    "aws_user_pools_id": "eu-west-3_sImiuYHn7",
    "aws_user_pools_web_client_id": "5h6t6rgriqcm8sojm4sauum1qa",
    "oauth": {
         domain: 'beonwall.auth.eu-west-3.amazoncognito.com',
         scope: ['email', 'openid', 'profile'],
         redirectSignIn: 'https://www.beonwall.com/login',
         redirectSignOut: 'https://www.beonwall.com/login',
         responseType: 'code'
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
